/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as IndexRouteImport } from './routes/index';
import { Route as AccountRouteImport } from './routes/account';
import { Route as BookRouteImport } from './routes/book';
import { Route as InsuranceRouteImport } from './routes/insurance';
import { Route as LoginRouteImport } from './routes/login';
import { Route as PaperworkRouteImport } from './routes/paperwork';
import { Route as PaymentRouteImport } from './routes/payment';
import { Route as RegisterRouteImport } from './routes/register';
import { Route as ResetPasswordRouteImport } from './routes/reset-password';
import { Route as AccountIndexRouteImport } from './routes/account/index';
import { Route as AccountIntakeRouteImport } from './routes/account/intake';
import { Route as AccountMessagesRouteImport } from './routes/account/messages';
import { Route as AccountPaymentRouteImport } from './routes/account/payment';
import { Route as AccountPreferencesRouteImport } from './routes/account/preferences';
import { Route as AccountProfileRouteImport } from './routes/account/profile';
import { Route as AccountWaitlistRouteImport } from './routes/account/waitlist';
import { Route as AuthLinkRouteImport } from './routes/auth.link';
import { Route as AuthSecureLinkRouteImport } from './routes/auth.secure-link';
import { Route as EmbedCardRouteImport } from './routes/embed.card';
import { Route as AccountAppointmentsIdIndexRouteImport } from './routes/account/appointments.$id.index';
import { Route as AccountAppointmentsIdRescheduleRouteImport } from './routes/account/appointments.$id.reschedule';

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any);
const BookRoute = BookRouteImport.update({
  id: '/book',
  path: '/book',
  getParentRoute: () => rootRouteImport,
} as any);
const InsuranceRoute = InsuranceRouteImport.update({
  id: '/insurance',
  path: '/insurance',
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const PaperworkRoute = PaperworkRouteImport.update({
  id: '/paperwork',
  path: '/paperwork',
  getParentRoute: () => rootRouteImport,
} as any);
const PaymentRoute = PaymentRouteImport.update({
  id: '/payment',
  path: '/payment',
  getParentRoute: () => rootRouteImport,
} as any);
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any);
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any);
const AccountIndexRoute = AccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AccountRoute,
} as any);
const AccountIntakeRoute = AccountIntakeRouteImport.update({
  id: '/intake',
  path: '/intake',
  getParentRoute: () => AccountRoute,
} as any);
const AccountMessagesRoute = AccountMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AccountRoute,
} as any);
const AccountPaymentRoute = AccountPaymentRouteImport.update({
  id: '/payment',
  path: '/payment',
  getParentRoute: () => AccountRoute,
} as any);
const AccountPreferencesRoute = AccountPreferencesRouteImport.update({
  id: '/preferences',
  path: '/preferences',
  getParentRoute: () => AccountRoute,
} as any);
const AccountProfileRoute = AccountProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AccountRoute,
} as any);
const AccountWaitlistRoute = AccountWaitlistRouteImport.update({
  id: '/waitlist',
  path: '/waitlist',
  getParentRoute: () => AccountRoute,
} as any);
const AuthLinkRoute = AuthLinkRouteImport.update({
  id: '/auth/link',
  path: '/auth/link',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthSecureLinkRoute = AuthSecureLinkRouteImport.update({
  id: '/auth/secure-link',
  path: '/auth/secure-link',
  getParentRoute: () => rootRouteImport,
} as any);
const EmbedCardRoute = EmbedCardRouteImport.update({
  id: '/embed/card',
  path: '/embed/card',
  getParentRoute: () => rootRouteImport,
} as any);
const AccountAppointmentsIdIndexRoute =
  AccountAppointmentsIdIndexRouteImport.update({
    id: '/appointments/$id/',
    path: '/appointments/$id/',
    getParentRoute: () => AccountRoute,
  } as any);
const AccountAppointmentsIdRescheduleRoute =
  AccountAppointmentsIdRescheduleRouteImport.update({
    id: '/appointments/$id/reschedule',
    path: '/appointments/$id/reschedule',
    getParentRoute: () => AccountRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/account': typeof AccountRouteWithChildren;
  '/book': typeof BookRoute;
  '/insurance': typeof InsuranceRoute;
  '/login': typeof LoginRoute;
  '/paperwork': typeof PaperworkRoute;
  '/payment': typeof PaymentRoute;
  '/register': typeof RegisterRoute;
  '/reset-password': typeof ResetPasswordRoute;
  '/account/intake': typeof AccountIntakeRoute;
  '/account/messages': typeof AccountMessagesRoute;
  '/account/payment': typeof AccountPaymentRoute;
  '/account/preferences': typeof AccountPreferencesRoute;
  '/account/profile': typeof AccountProfileRoute;
  '/account/waitlist': typeof AccountWaitlistRoute;
  '/auth/link': typeof AuthLinkRoute;
  '/auth/secure-link': typeof AuthSecureLinkRoute;
  '/embed/card': typeof EmbedCardRoute;
  '/account/': typeof AccountIndexRoute;
  '/account/appointments/$id/reschedule': typeof AccountAppointmentsIdRescheduleRoute;
  '/account/appointments/$id/': typeof AccountAppointmentsIdIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/book': typeof BookRoute;
  '/insurance': typeof InsuranceRoute;
  '/login': typeof LoginRoute;
  '/paperwork': typeof PaperworkRoute;
  '/payment': typeof PaymentRoute;
  '/register': typeof RegisterRoute;
  '/reset-password': typeof ResetPasswordRoute;
  '/account/intake': typeof AccountIntakeRoute;
  '/account/messages': typeof AccountMessagesRoute;
  '/account/payment': typeof AccountPaymentRoute;
  '/account/preferences': typeof AccountPreferencesRoute;
  '/account/profile': typeof AccountProfileRoute;
  '/account/waitlist': typeof AccountWaitlistRoute;
  '/auth/link': typeof AuthLinkRoute;
  '/auth/secure-link': typeof AuthSecureLinkRoute;
  '/embed/card': typeof EmbedCardRoute;
  '/account': typeof AccountIndexRoute;
  '/account/appointments/$id/reschedule': typeof AccountAppointmentsIdRescheduleRoute;
  '/account/appointments/$id': typeof AccountAppointmentsIdIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/account': typeof AccountRouteWithChildren;
  '/book': typeof BookRoute;
  '/insurance': typeof InsuranceRoute;
  '/login': typeof LoginRoute;
  '/paperwork': typeof PaperworkRoute;
  '/payment': typeof PaymentRoute;
  '/register': typeof RegisterRoute;
  '/reset-password': typeof ResetPasswordRoute;
  '/account/intake': typeof AccountIntakeRoute;
  '/account/messages': typeof AccountMessagesRoute;
  '/account/payment': typeof AccountPaymentRoute;
  '/account/preferences': typeof AccountPreferencesRoute;
  '/account/profile': typeof AccountProfileRoute;
  '/account/waitlist': typeof AccountWaitlistRoute;
  '/auth/link': typeof AuthLinkRoute;
  '/auth/secure-link': typeof AuthSecureLinkRoute;
  '/embed/card': typeof EmbedCardRoute;
  '/account/': typeof AccountIndexRoute;
  '/account/appointments/$id/reschedule': typeof AccountAppointmentsIdRescheduleRoute;
  '/account/appointments/$id/': typeof AccountAppointmentsIdIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/account'
    | '/book'
    | '/insurance'
    | '/login'
    | '/paperwork'
    | '/payment'
    | '/register'
    | '/reset-password'
    | '/account/intake'
    | '/account/messages'
    | '/account/payment'
    | '/account/preferences'
    | '/account/profile'
    | '/account/waitlist'
    | '/auth/link'
    | '/auth/secure-link'
    | '/embed/card'
    | '/account/'
    | '/account/appointments/$id/reschedule'
    | '/account/appointments/$id/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/book'
    | '/insurance'
    | '/login'
    | '/paperwork'
    | '/payment'
    | '/register'
    | '/reset-password'
    | '/account/intake'
    | '/account/messages'
    | '/account/payment'
    | '/account/preferences'
    | '/account/profile'
    | '/account/waitlist'
    | '/auth/link'
    | '/auth/secure-link'
    | '/embed/card'
    | '/account'
    | '/account/appointments/$id/reschedule'
    | '/account/appointments/$id';
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/book'
    | '/insurance'
    | '/login'
    | '/paperwork'
    | '/payment'
    | '/register'
    | '/reset-password'
    | '/account/intake'
    | '/account/messages'
    | '/account/payment'
    | '/account/preferences'
    | '/account/profile'
    | '/account/waitlist'
    | '/auth/link'
    | '/auth/secure-link'
    | '/embed/card'
    | '/account/'
    | '/account/appointments/$id/reschedule'
    | '/account/appointments/$id/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AccountRoute: typeof AccountRouteWithChildren;
  BookRoute: typeof BookRoute;
  InsuranceRoute: typeof InsuranceRoute;
  LoginRoute: typeof LoginRoute;
  PaperworkRoute: typeof PaperworkRoute;
  PaymentRoute: typeof PaymentRoute;
  RegisterRoute: typeof RegisterRoute;
  ResetPasswordRoute: typeof ResetPasswordRoute;
  AuthLinkRoute: typeof AuthLinkRoute;
  AuthSecureLinkRoute: typeof AuthSecureLinkRoute;
  EmbedCardRoute: typeof EmbedCardRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/account': {
      id: '/account';
      path: '/account';
      fullPath: '/account';
      preLoaderRoute: typeof AccountRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/book': {
      id: '/book';
      path: '/book';
      fullPath: '/book';
      preLoaderRoute: typeof BookRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/insurance': {
      id: '/insurance';
      path: '/insurance';
      fullPath: '/insurance';
      preLoaderRoute: typeof InsuranceRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/paperwork': {
      id: '/paperwork';
      path: '/paperwork';
      fullPath: '/paperwork';
      preLoaderRoute: typeof PaperworkRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/payment': {
      id: '/payment';
      path: '/payment';
      fullPath: '/payment';
      preLoaderRoute: typeof PaymentRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/register': {
      id: '/register';
      path: '/register';
      fullPath: '/register';
      preLoaderRoute: typeof RegisterRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/reset-password': {
      id: '/reset-password';
      path: '/reset-password';
      fullPath: '/reset-password';
      preLoaderRoute: typeof ResetPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/account/': {
      id: '/account/';
      path: '/';
      fullPath: '/account/';
      preLoaderRoute: typeof AccountIndexRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/intake': {
      id: '/account/intake';
      path: '/intake';
      fullPath: '/account/intake';
      preLoaderRoute: typeof AccountIntakeRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/messages': {
      id: '/account/messages';
      path: '/messages';
      fullPath: '/account/messages';
      preLoaderRoute: typeof AccountMessagesRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/payment': {
      id: '/account/payment';
      path: '/payment';
      fullPath: '/account/payment';
      preLoaderRoute: typeof AccountPaymentRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/preferences': {
      id: '/account/preferences';
      path: '/preferences';
      fullPath: '/account/preferences';
      preLoaderRoute: typeof AccountPreferencesRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/profile': {
      id: '/account/profile';
      path: '/profile';
      fullPath: '/account/profile';
      preLoaderRoute: typeof AccountProfileRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/waitlist': {
      id: '/account/waitlist';
      path: '/waitlist';
      fullPath: '/account/waitlist';
      preLoaderRoute: typeof AccountWaitlistRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/auth/link': {
      id: '/auth/link';
      path: '/auth/link';
      fullPath: '/auth/link';
      preLoaderRoute: typeof AuthLinkRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/auth/secure-link': {
      id: '/auth/secure-link';
      path: '/auth/secure-link';
      fullPath: '/auth/secure-link';
      preLoaderRoute: typeof AuthSecureLinkRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/embed/card': {
      id: '/embed/card';
      path: '/embed/card';
      fullPath: '/embed/card';
      preLoaderRoute: typeof EmbedCardRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/account/appointments/$id/': {
      id: '/account/appointments/$id/';
      path: '/appointments/$id';
      fullPath: '/account/appointments/$id/';
      preLoaderRoute: typeof AccountAppointmentsIdIndexRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/appointments/$id/reschedule': {
      id: '/account/appointments/$id/reschedule';
      path: '/appointments/$id/reschedule';
      fullPath: '/account/appointments/$id/reschedule';
      preLoaderRoute: typeof AccountAppointmentsIdRescheduleRouteImport;
      parentRoute: typeof AccountRoute;
    };
  }
}

interface AccountRouteChildren {
  AccountIntakeRoute: typeof AccountIntakeRoute;
  AccountMessagesRoute: typeof AccountMessagesRoute;
  AccountPaymentRoute: typeof AccountPaymentRoute;
  AccountPreferencesRoute: typeof AccountPreferencesRoute;
  AccountProfileRoute: typeof AccountProfileRoute;
  AccountWaitlistRoute: typeof AccountWaitlistRoute;
  AccountIndexRoute: typeof AccountIndexRoute;
  AccountAppointmentsIdRescheduleRoute: typeof AccountAppointmentsIdRescheduleRoute;
  AccountAppointmentsIdIndexRoute: typeof AccountAppointmentsIdIndexRoute;
}

const AccountRouteChildren: AccountRouteChildren = {
  AccountIntakeRoute: AccountIntakeRoute,
  AccountMessagesRoute: AccountMessagesRoute,
  AccountPaymentRoute: AccountPaymentRoute,
  AccountPreferencesRoute: AccountPreferencesRoute,
  AccountProfileRoute: AccountProfileRoute,
  AccountWaitlistRoute: AccountWaitlistRoute,
  AccountIndexRoute: AccountIndexRoute,
  AccountAppointmentsIdRescheduleRoute: AccountAppointmentsIdRescheduleRoute,
  AccountAppointmentsIdIndexRoute: AccountAppointmentsIdIndexRoute,
};

const AccountRouteWithChildren =
  AccountRoute._addFileChildren(AccountRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRouteWithChildren,
  BookRoute: BookRoute,
  InsuranceRoute: InsuranceRoute,
  LoginRoute: LoginRoute,
  PaperworkRoute: PaperworkRoute,
  PaymentRoute: PaymentRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  AuthLinkRoute: AuthLinkRoute,
  AuthSecureLinkRoute: AuthSecureLinkRoute,
  EmbedCardRoute: EmbedCardRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
